var _g, _g2, _rect, _rect2, _circle, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentLoadingSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 80,
    viewBox: "0 0 346 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11279_16280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 326,
    height: 60,
    rx: 2,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11279_16280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303 25H319C319.265 25 319.52 25.1054 319.707 25.2929C319.895 25.4804 320 25.7348 320 26V42C320 42.2652 319.895 42.5196 319.707 42.7071C319.52 42.8946 319.265 43 319 43H303C302.735 43 302.48 42.8946 302.293 42.7071C302.105 42.5196 302 42.2652 302 42V26C302 25.7348 302.105 25.4804 302.293 25.2929C302.48 25.1054 302.735 25 303 25ZM310.003 38L317.073 30.929L315.659 29.515L310.003 35.172L307.174 32.343L305.76 33.757L310.003 38Z",
    fill: "#121B2E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 22,
    width: 107,
    height: 8,
    rx: 3.4,
    fill: "#EBEBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 38,
    width: 59,
    height: 8,
    rx: 3.4,
    fill: "#EBEBEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 36,
    r: 21,
    fill: "#EBEBEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11279_16280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 26C49.02 26 53.5 30.48 53.5 36C53.5 41.52 49.02 46 43.5 46C37.98 46 33.5 41.52 33.5 36C33.5 30.48 37.98 26 43.5 26ZM37.523 39.416C38.991 41.606 41.195 43 43.66 43C46.124 43 48.329 41.607 49.796 39.416C48.1317 37.8606 45.9379 36.9968 43.66 37C41.3817 36.9966 39.1875 37.8604 37.523 39.416ZM43.5 35C44.2956 35 45.0587 34.6839 45.6213 34.1213C46.1839 33.5587 46.5 32.7956 46.5 32C46.5 31.2044 46.1839 30.4413 45.6213 29.8787C45.0587 29.3161 44.2956 29 43.5 29C42.7044 29 41.9413 29.3161 41.3787 29.8787C40.8161 30.4413 40.5 31.2044 40.5 32C40.5 32.7956 40.8161 33.5587 41.3787 34.1213C41.9413 34.6839 42.7044 35 43.5 35Z",
    fill: "#09121F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11279_16280",
    x: 0,
    y: 0,
    width: 346,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11279_16280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11279_16280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11279_16280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(299 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11279_16280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(31.5 24)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLoadingSmall);
export default __webpack_public_path__ + "static/media/content_loading_small.36ad84a9913e6be16a899df1fcb5bbed.svg";
export { ForwardRef as ReactComponent };